'use client';

import Link from "next/link";
import SafeHtmlRenderer from "./SafeHtmlRenderer";

interface NewsItem {
  id: number;
  newsHeadline: string;
  topic?: string | null;
  publicationDate: Date;
  isFeatured?: boolean | null;
  newsBody: string;
  newsCoverImg?: string | null;
}

interface NewsListProps {
  newsItems: NewsItem[];
}

const NewsList = ({ newsItems }: NewsListProps) => {
  return (
    <div className="p-4 rounded-md mb-2">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-center gap-6 mt-4">
  {newsItems.length === 0 ? (
    <p className="text-gray-500 text-sm col-span-full text-center">No recent news available</p>
  ) : (
    newsItems.map((item) => (
      <Link
        href={`/news/${item.id}`}
        key={item.id}
        className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition flex flex-col h-full"
      >
        <div className="relative w-full h-48">
          <img
            src={item.newsCoverImg ?? "/assets/images/placeholder.png"}
            alt={item.newsHeadline}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="p-4 flex flex-col justify-between flex-grow">
          <h3 className="text-[15px] md:text-xl font-bold hyphens-auto md:hyphens-none text-[#001F3F] leading-snug line-clamp-3 md:line-clamp-4">
            {item.newsHeadline}
          </h3>
          <p className="safer-html-renderer text-sm md:text-[16px] text-gray-700 mt-2 leading-relaxed line-clamp-2 md:line-clamp-4">
            <SafeHtmlRenderer html={item.newsBody}/>
          </p>
          <p className="text-sm text-gray-700 mt-4">
            {new Intl.DateTimeFormat("en-GB", {
              year: "numeric",
              month: "short",
              day: "numeric",
            }).format(new Date(item.publicationDate))}
          </p>
        </div>
      </Link>
    ))
  )}
</div>

    </div>
  );
};

export default NewsList;